// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1_CuX","upload":"Small_upload__1JdSu","imageWrap":"Small_imageWrap__31lBh","removeBtn":"Small_removeBtn__t5Wwy"};